export enum CardApplicationStatus {
  Created = 1,
  OnReview,
  Accepted,
  Declined,
}
